function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.278 12.263h-.9l-.318-.3c2.6-2.954 2.34-7.385-.587-10.032-2.927-2.647-7.476-2.563-10.298.19a7.118 7.118 0 00-.196 10.048c2.713 2.856 7.255 3.109 10.283.572l.308.311v.878l4.84 4.722c.47.454 1.227.454 1.697 0a1.157 1.157 0 000-1.655l-4.829-4.734zm-6.833 0c-2.073 0-3.942-1.218-4.735-3.086a4.911 4.911 0 011.111-5.45c1.466-1.43 3.67-1.857 5.585-1.083s3.164 2.597 3.164 4.62a4.928 4.928 0 01-1.498 3.538 5.18 5.18 0 01-3.627 1.461z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgSearchWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearchWhite;